<template>
  <!-- <div style="background-color: #f5f5f5;"> -->
  <div>
    <Topo />
    <b-container>
      <b-form @submit="onSubmit">
        <h3 class="mb-4 text-center"><b><u>Formulário de Inscrição</u></b></h3>
        <b-card header="Dados Pessoais">
          <div class="row">
            <div class="col-md-10">
              <b-form-group label="Nome" label-for="nome">
                <b-form-input id="nome"  maxlength="80" size="sm"
                  v-model.trim="$v.form.nome.$model"
                  :state="$v.form.nome.$dirty ? !$v.form.nome.$error : null"
                  aria-describedby="input-1-live-feedback">
                </b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback">
                  <div v-if="!$v.form.nome.required">Campo obrigatório</div>
                  <div v-if="!$v.form.nome.minLength">Mínimo de 10 caracteres</div>
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group label="CPF" label-for="cpf">
                <b-form-input id="cpf" size="sm" v-model="form.cpf" class="text-center" style="max-width: 9rem;" readonly></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group label="Nome reduzido para credencial" label-for="cracha">
                <b-form-input id="cracha" maxlength="20" size="sm"
                  v-model.trim="$v.form.cracha.$model"
                  :state="$v.form.cracha.$dirty ? !$v.form.cracha.$error : null"
                  aria-describedby="input-1-live-feedback">
                </b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Especialidade" label-for="especialidade">
                <b-form-select size="sm" v-model="$v.form.id_profissao.$model"
                  :state="$v.form.id_profissao.$dirty ? !$v.form.id_profissao.$error : null"
                  aria-describedby="input-1-live-feedback">
                  <option :value="null"></option>
                  <option :key="especialidade.id" v-for="especialidade in especialidades" :value="especialidade.id">{{especialidade.nome}}</option>
                </b-form-select>
                <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group label="CRM" label-for="crm">
                <b-form-input id="crm" maxlength="20" size="sm"
                  v-model.trim="form.crm">
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group label="UF" label-for="uf">
                <b-form-select size="sm"
                  v-model.trim="form.ufcrm">
                  <option value></option>
                  <option value="AC">AC</option>
                  <option value="AL">AL</option>
                  <option value="AM">AM</option>
                  <option value="AP">AP</option>
                  <option value="BA">BA</option>
                  <option value="CE">CE</option>
                  <option value="DF">DF</option>
                  <option value="ES">ES</option>
                  <option value="GO">GO</option>
                  <option value="MA">MA</option>
                  <option value="MG">MG</option>
                  <option value="MS">MS</option>
                  <option value="MT">MT</option>
                  <option value="PA">PA</option>
                  <option value="PB">PB</option>
                  <option value="PE">PE</option>
                  <option value="PI">PI</option>
                  <option value="PR">PR</option>
                  <option value="RJ">RJ</option>
                  <option value="RN">RN</option>
                  <option value="RO">RO</option>
                  <option value="RR">RR</option>
                  <option value="RS">RS</option>
                  <option value="SC">SC</option>
                  <option value="SE">SE</option>
                  <option value="SP">SP</option>
                  <option value="TO">TO</option>
                </b-form-select>
              </b-form-group>
            </div>
          </div>
        </b-card>

        <b-card header="Endereço" class="mt-3">
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="CEP" label-for="cep">
                <b-form-input id="cep" v-mask="'##.###-###'" v-on:keyup="BuscaCep()" size="sm"
                  v-model.trim="$v.form.cep.$model"
                  :state="$v.form.cep.$dirty ? !$v.form.cep.$error : null"
                  aria-describedby="input-1-live-feedback">
                </b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Endereço" label-for="endereco">
                <b-form-input id="endereco" ref="endereco" maxlength="80" size="sm"
                  v-model.trim="$v.form.endereco.$model"
                  :state="$v.form.endereco.$dirty ? !$v.form.endereco.$error : null"
                  aria-describedby="input-1-live-feedback">
                </b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group label="Número" label-for="numero">
                <b-form-input id="numero" ref="numero" maxlength="10" size="sm"
                  v-model.trim="$v.form.numero.$model"
                  :state="$v.form.numero.$dirty ? !$v.form.numero.$error : null"
                  aria-describedby="input-1-live-feedback">
                </b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Complemento" label-for="complemento">
                <b-form-input id="complemento" v-model="form.complemento" maxlength="50" size="sm"></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5">
              <b-form-group label="Bairro" label-for="bairro">
                <b-form-input id="bairro" maxlength="50" size="sm"
                  v-model.trim="$v.form.bairro.$model"
                  :state="$v.form.bairro.$dirty ? !$v.form.bairro.$error : null"
                  aria-describedby="input-1-live-feedback">
                </b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-md-5">
              <b-form-group label="Cidade" label-for="cidade">
                <b-form-input id="cidade" maxlength="50" size="sm"
                  v-model.trim="$v.form.cidade.$model"
                  :state="$v.form.cidade.$dirty ? !$v.form.cidade.$error : null"
                  aria-describedby="input-1-live-feedback">
                </b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group label="UF" label-for="uf">
                <b-form-select size="sm"
                  v-model.trim="$v.form.uf.$model"
                  :state="$v.form.uf.$dirty ? !$v.form.uf.$error : null"
                  aria-describedby="input-1-live-feedback">
                  <option value></option>
                  <option value="AC">AC</option>
                  <option value="AL">AL</option>
                  <option value="AM">AM</option>
                  <option value="AP">AP</option>
                  <option value="BA">BA</option>
                  <option value="CE">CE</option>
                  <option value="DF">DF</option>
                  <option value="ES">ES</option>
                  <option value="GO">GO</option>
                  <option value="MA">MA</option>
                  <option value="MG">MG</option>
                  <option value="MS">MS</option>
                  <option value="MT">MT</option>
                  <option value="PA">PA</option>
                  <option value="PB">PB</option>
                  <option value="PE">PE</option>
                  <option value="PI">PI</option>
                  <option value="PR">PR</option>
                  <option value="RJ">RJ</option>
                  <option value="RN">RN</option>
                  <option value="RO">RO</option>
                  <option value="RR">RR</option>
                  <option value="RS">RS</option>
                  <option value="SC">SC</option>
                  <option value="SE">SE</option>
                  <option value="SP">SP</option>
                  <option value="TO">TO</option>
                </b-form-select>
                <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Telefone 01" label-for="telefone_pref">
                <table>
                  <tr>
                    <td class="text-right">
                      <b-form-input id="telefone_pref" maxlength="2" class="preftel" size="sm"
                        v-model.trim="$v.form.telefone_pref.$model"
                        :state="$v.form.telefone_pref.$dirty ? !$v.form.telefone_pref.$error : null"
                        aria-describedby="input-1-live-feedback">
                      </b-form-input>
                      <b-form-invalid-feedback id="input-1-live-feedback">*</b-form-invalid-feedback>
                    </td>
                    <td>
                      <b-form-input id="telefone" maxlength="10" class="tel" size="sm"
                        v-model.trim="$v.form.telefone.$model"
                        :state="$v.form.telefone.$dirty ? !$v.form.telefone.$error : null"
                        aria-describedby="input-1-live-feedback">
                      </b-form-input>
                      <b-form-invalid-feedback id="input-1-live-feedback">
                        <div v-if="!$v.form.telefone.required">Campo obrigatório</div>
                        <div v-if="!$v.form.telefone.minLength">Mínimo de 8 dígitos</div>
                      </b-form-invalid-feedback>
                    </td>
                  </tr>
                </table>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Telefone 02" label-for="fax_pref">
                <table>
                  <tr>
                    <td>
                      <b-form-input id="fax_pref" v-model="form.fax_pref" maxlength="2" class="preftel" size="sm"></b-form-input>
                    </td>
                    <td>
                      <b-form-input id="fax" v-model="form.fax" maxlength="10" class="tel" size="sm"></b-form-input>
                    </td>
                  </tr>
                </table>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Telefone 03" label-for="celular_pref">
                <table>
                  <tr>
                    <td>
                      <b-form-input
                        id="celular_pref" v-model="form.celular_pref" maxlength="2" class="preftel" size="sm"></b-form-input>
                    </td>
                    <td>
                      <b-form-input
                        id="celular" v-model="form.celular" maxlength="10" class="tel" size="sm"></b-form-input>
                    </td>
                  </tr>
                </table>
              </b-form-group>
            </div>
          </div>
        </b-card>

        <b-card header="Dados de Acesso" class="mt-3">
          <div class="row">
            <div class="col-md-6">
              <b-form-group label="Email" label-for="email">
                <b-form-input id="email" size="sm" maxlength="80"
                  v-model.trim="$v.form.email.$model"
                  :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
                  aria-describedby="input-1-live-feedback">
                </b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback">
                  <div v-if="!$v.form.email.required">Campo obrigatório</div>
                  <div v-if="!$v.form.email.email">Endereço de e-mail inválido!</div>
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Senha" label-for="senha">
                <b-form-input id="senha" size="sm" type="password" maxlength="20"
                  placeholder="mínimo de 6 caracteres"
                  v-model.trim="$v.form.senha.$model"
                  :state="$v.form.senha.$dirty ? !$v.form.senha.$error : null"
                  aria-describedby="input-1-live-feedback">
                </b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback">
                  <div v-if="!$v.form.senha.required">Campo obrigatório</div>
                  <div v-if="!$v.form.senha.minLength">Mínimo de 6 caracteres</div>
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Redigite" label-for="redigite">
                <b-form-input id="redigite" size="sm" type="password" maxlength="20"
                  v-model.trim="$v.form.redigite.$model"
                  :state="$v.form.redigite.$dirty ? !$v.form.redigite.$error : null"
                  aria-describedby="input-1-live-feedback">
                </b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback">
                  <div v-if="!$v.form.redigite.required">Campo obrigatório</div>
                  <div v-if="!$v.form.redigite.sameAsPassword">Redigitação da senha não confere!</div>
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
          <b-form-group label="Lembrete da Senha" label-for="lembrete">
            <b-form-input id="lembrete" size="sm" maxlength="50"
              v-model.trim="$v.form.lembrete.$model"
              :state="$v.form.lembrete.$dirty ? !$v.form.lembrete.$error : null"
              aria-describedby="input-1-live-feedback">
            </b-form-input>
            <b-form-invalid-feedback id="input-1-live-feedback">Campo obrigatório</b-form-invalid-feedback>
          </b-form-group>
        </b-card>

        <div class="row mt-3">
          <div class="col-md-12">
            <b-card header="Selecione as atividades que deseja participar:" class="text-left">
              <table class="table">
                <tr>
                  <th></th>
                  <th>Atividade</th>
                  <th>Data/Horário</th>
                  <th>Local</th>
                  <th style="text-align: right">Valor</th>
                </tr>
                <tr v-for="p in programacoes" v-bind:key="p.id" v-bind:class="{ inativo: !p.tem_vaga }">
                  <td>
                    <input type="checkbox" v-if="p.tem_vaga" v-model="form.selected" :value="p" :id="'checkprog_' + p.id" @change="onRowSelected('checkprog_' + p.id)">
                  </td>
                  <td>{{ p.nome_completo }}</td>
                  <td v-bind:colspan="!p.tem_vaga ? 2 : 0">
                    <div class="text-center" v-if="!p.tem_vaga"><b>****** VAGAS ESGOTADAS ******</b></div>
                    <span v-else v-html="p.datas"></span>
                  </td>
                  <td v-if="p.tem_vaga">{{ p.local }}</td>
                  <td style="text-align: right">{{ $store.state.isencao === 'T' || $store.state.isencao === 'F' ? 'ISENTO' : formatPrice(p.valor) }}</td>
                </tr>
              </table>
              <!-- {{ form.selected }} -->
            </b-card>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-6">
            <b-card header="Forma de Pagamento" class="text-center">
              <img src="@/assets/boleto.png" class="img img-responsive" style="max-height: 70px;" alt="Logo">
            </b-card>
          </div>
          <div class="col-md-6">
            <b-card header="Resumo da Inscrição" class="text-right">
              Total da Inscrição:
              <b class="ml-1" v-if="$store.state.cupom && form.taxa_de_inscricao === 0">ISENTO</b>
              <b class="ml-1" v-else>{{ formatPrice(form.taxa_de_inscricao) }}</b>
            </b-card>
          </div>
        </div>

        <div class="text-center mt-4 mb-4">
          <!-- <b-button v-if="!trabalhando" @click="Avancar()" variant="primary">Avançar</b-button> -->
          <b-button v-if="!trabalhando" type="submit" variant="primary">Avançar</b-button>
          <b-button v-else variant="primary" disabled>
            <b-spinner small class="mr-2"></b-spinner>Trabalhando...
          </b-button>
        </div>

        <b-alert show variant="warning" class="mt-3" style="margin-bottom: 3rem;">
          Recomendamos cadastrar no seu programa de email o contato
          <b>suporte-cariocao@wgs.com.br</b>
          para que as mensagens enviadas por este site não sejam confundidas com spams e sejam automaticamente bloqueadas.
        </b-alert>
      </b-form>
    </b-container>
  </div>
</template>

<script>
import Topo from '@/components/Topo.vue'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'Ficha',
  mixins: [validationMixin],
  components: { Topo },
  data () {
    return {
      id: null,
      IDCrip: '',
      IDCripPC: '',
      atividades_extras: [],
      resumo: [],
      especialidades: [],
      dados_email_cadastro: {},
      email: {},
      email_ps: '',
      token_ps: '',
      total: null,
      trabalhando: false,
      programacoes: [],
      programacoes_datas: [],
      programacoes_datas_sel: [],
      campos: [
        { key: 'show_details', label: '', sortable: false },
        { key: 'nome_completo', label: 'Atividade', sortable: false },
        { key: 'datas', label: 'Data/Horário', sortable: false },
        { key: 'valor', label: 'Valor', sortable: false, thStyle: 'text-align: right', tdStyle: 'text-align: right' }
      ],
      form: {
        id_cliente: 1,
        id_eve: 1,
        nome: '',
        cracha: '',
        // dtnasc: '',
        id_categoria: this.$store.state.ficha_id_categoria,
        cupom: this.$store.state.cupom,
        id_profissao: null,
        crm: '',
        ufcrm: '',
        cpf: this.$store.state.ficha_cpf,
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        uf: '',
        telefone_pref: '',
        telefone: '',
        fax_pref: '',
        fax: '',
        celular_pref: '',
        celular: '',
        email: '',
        senha: '',
        redigite: '',
        lembrete: '',
        datainscr: null,
        taxa_de_inscricao: 0,
        selected: []
      },
      valor_total: 0,
      naoLocalizadoRes: false
      // naoLocalizadoCom: false
    }
  },
  validations () {
    return {
      form: {
        nome: {
          required,
          minLength: minLength(10)
        },
        cracha: { required },
        id_profissao: { required },
        cep: { required },
        endereco: { required },
        numero: { required },
        bairro: { required },
        cidade: { required },
        uf: { required },
        telefone_pref: { required },
        telefone: {
          required,
          minLength: minLength(8)
        },
        email: { required, email },
        senha: {
          required,
          minLength: minLength(6)
        },
        redigite: { required, sameAsPassword: sameAs('senha') },
        lembrete: { required }
      }
    }
  },
  methods: {
    onRowSelected (controleCheck) {
      // console.log('Controle: ', controleCheck)
      // SELECIONA DATAS
      let selecionados = []
      for (let i = 0; i < this.form.selected.length; i = i + 1) {
        for (let a = 0; a < this.programacoes_datas.length; a = a + 1) {
          if (this.form.selected[i].id === this.programacoes_datas[a].id_programacao) {
            selecionados.push(this.programacoes_datas[a])
          }
        }
      }

      let sairDoLaco = false

      // VERIFICA COINCIDENCIA DE HORÁRIOS
      for (let x = 0; x < selecionados.length; x = x + 1) {
        let hi1 = new Date('2020-01-01 ' + selecionados[x].hi)
        let ht1 = new Date('2020-01-01 ' + selecionados[x].ht)
        if (sairDoLaco) break
        for (let y = 0; y < selecionados.length; y = y + 1) {
          let hi2 = new Date('2020-01-01 ' + selecionados[y].hi)
          let ht2 = new Date('2020-01-01 ' + selecionados[y].ht)
          if (x !== y && selecionados[x].dia === selecionados[y].dia) {
            if (hi2.getTime() >= hi1.getTime() && hi2.getTime() <= ht1.getTime()) {
              // console.log(`A atividade ${selecionados[x].nome_completo} coincide com ${selecionados[y].nome_completo}!!`)
              this.$toasted.global.defaultError({ msg: `<table><tr><td class='pb-2'>Existe um conflito de horários entre as atividades</td></tr><tr><td class='text-center pb-2'>${selecionados[x].nome_completo}</td></tr><tr><td class='text-center pb-2'>e</td></tr><tr><td class='text-center pb-2'>${selecionados[y].nome_completo}</td></tr></table>` })
              sairDoLaco = true
              // let meuPop = this.form.selected.pop()
              this.form.selected.pop()
              window.document.getElementById(controleCheck).checked = false
              // console.log(meuPop)
              break
            } else {
              if (ht2.getTime() <= ht1.getTime() && ht2.getTime() >= hi1.getTime()) {
                sairDoLaco = true
                // console.log(`A atividade ${selecionados[x].nome_completo} coincide com ${selecionados[y].nome_completo}!!`)
                this.$toasted.global.defaultError({ msg: `Existe um conflito de horários entre as atividades<br />${selecionados[x].nome_completo}\ne\n${selecionados[y].nome_completo}!!` })
                // let meuPop2 = this.form.selected.pop()
                this.form.selected.pop()
                // console.log(controleCheck)
                window.document.getElementById(controleCheck).checked = false
                // console.log(meuPop2)
                break
              }
            }
          }
        }
      }
      const total = this.form.selected.map(a => a.valor).reduce(function (acumulador, atual) {
        return acumulador + atual
      })
      this.form.taxa_de_inscricao = total
    },
    ValidaNome () {
      return this.form.nome.length >= this.form.cracha.length
    },
    BuscaCep (VCep) {
      const teclas = ['Shift', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown']
      if (teclas.includes(event.key)) return
      this.naoLocalizadoRes = false
      let cep = ''

      if (this.form.cep.length === 10) {
        cep = this.form.cep.replace(/[^\d]+/g, '')
        axios.get('https://viacep.com.br/ws/' + cep + '/json/')
          .then(endereco => {
            if (endereco.erro) {
              this.form.endereco = ''
              this.form.numero = ''
              this.form.bairro = ''
              this.form.complemento = ''
              this.form.cidade = ''
              this.form.uf = ''
              this.$refs.endereco.focus()
              this.naoLocalizadoRes = true
              return
            }
            this.form.endereco = endereco.data.logradouro
            this.form.numero = ''
            this.form.bairro = endereco.data.bairro
            this.form.complemento = ''
            this.form.cidade = endereco.data.localidade
            this.form.uf = endereco.data.uf
            this.$refs.numero.focus()
          })
      }
    },
    onSubmit (evt) {
      evt.preventDefault()
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toasted.global.defaultError({ msg: 'Por favor, verifique os erros no formulário' })
      } else {
        if (this.ValidaNome()) {
          if (this.form.id_categoria < 9 && (!this.form.crm || !this.form.ufcrm)) {
            this.$toasted.global.defaultError({ msg: 'Por favor, informe o CRM e a UF do CRM' })
          } else {
            if (this.form.selected.length === 0) {
              this.$toasted.global.defaultError({ msg: 'Obrigatório marcar ao menos uma atividade que deseja participar!' })
            } else {
              this.SalvaRegistro()
            }
          }
        } else {
          this.$toasted.global.defaultError({ msg: 'Nome completo não pode ser menor do que o nome para a credencial' })
        }
      }
    },
    SalvaRegistro () {
      this.trabalhando = true
      axios.post(`${baseApiUrl}/ficha/salvar`, this.form)
        .then(res => {
          const retorno = res.data.split('|')
          this.IDCrip = retorno[0]
          this.IDCripPC = retorno[1]
          this.id = retorno[2]
          this.$store.commit('setValorTotal', this.form.taxa_de_inscricao)
          this.PrepararEmailParticipante()
        })
        .catch(err => {
          showError(err)
          this.trabalhando = false
        })
    },
    PrepararEmailParticipante () {
      this.email = {
        id_crip: this.IDCrip,
        remetente: this.dados_email_cadastro.remetente,
        senha: this.dados_email_cadastro.senha,
        titulo: this.dados_email_cadastro.titulo,
        assunto: this.dados_email_cadastro.assunto,
        host: this.dados_email_cadastro.host,
        porta: this.dados_email_cadastro.porta,
        ssl: this.dados_email_cadastro.email_ssl,
        email: this.form.email,
        mensagem: this.dados_email_cadastro.mensagem,
        tipo_email: 'emailparticipante'
      }
      // SUBSTITUI CAMPOS DE MESCLAGEM
      /* eslint no-eval: 0 */
      let strbusca = eval('/' + '{C&oacute;digo da Inscri&ccedil;&atilde;o}' + '/g')
      this.email.mensagem = this.email.mensagem.replace(strbusca, ('00000000' + this.id).slice(-8))

      strbusca = eval('/' + '{Nome do Participante}' + '/g')
      this.email.mensagem = this.email.mensagem.replace(strbusca, this.form.nome)

      strbusca = eval('/' + '{E-mail}' + '/g')
      this.email.mensagem = this.email.mensagem.replace(strbusca, this.form.email)

      strbusca = eval('/' + '{CPF}' + '/g')
      this.email.mensagem = this.email.mensagem.replace(strbusca, this.form.cpf)

      this.EnviarEmaildeCadastro()
    },
    EnviarEmaildeCadastro () {
      // console.log('Entrou no EnviarEmaildeCadastro()')
      // axios.post(`${baseApiUrl}/envia_email/${this.IDCripPC}/${this.form.email}`)
      axios.post(`${baseApiUrl}/emailsg`, this.email)
        .then(() => {
          // this.$toasted.global.defaultSuccess({msg: "E-mail de confirmação de cadastro de sócio enviado com sucesso!"})
          this.$router.push({ path: `sucesso/${this.IDCripPC}` })
        })
        .catch(err => {
          showError(err)
          this.trabalhando = false
        })
      // this.trabalhando = false
    },
    VerificaValorTaxaInscr () {
      const url = `${baseApiUrl}/ficha/pega_valor_taxa_inscr/${this.$store.state.ficha_id_categoria}`
      axios.get(url)
        .then(res => {
          if (this.$store.state.cupom) {
            // console.log('Tem cupom: ', this.$store.state.cupom)
            if (this.$store.state.isencao === 'F' || this.$store.state.isencao === 'T') {
              // console.log('Tipo de Isenção F ou T: ', this.$store.state.isencao)
              this.form.taxa_de_inscricao = this.$store.state.valor_isencao
            } else {
              // console.log('Tipo de Isenção P: ', this.$store.state.isencao)
              this.form.taxa_de_inscricao = res.data.valor - ((res.data.valor * this.$store.state.valor_isencao) / 100)
            }
          } else {
            // console.log('Não tem cupom: ', res.data.valor)
            this.form.taxa_de_inscricao = res.data.valor
          }
          // console.log('Valor Isencao: ', this.$store.state.valor_isencao)
        })
        .catch(err => {
          showError(err)
        })
    },
    CarregaDados () {
      const url = `${baseApiUrl}/profissoes`
      axios.get(url)
        .then(res => {
          this.especialidades = res.data
        })
        .catch(err => {
          showError(err)
        })
    },
    CarregaProgramacoes () {
      const url = `${baseApiUrl}/programacao_ficha/${this.form.id_categoria}?isencao=${this.$store.state.isencao}`
      axios.get(url)
        .then(res => {
          this.programacoes = res.data
        })
        .catch(showError)
    },
    CarregaProgramacoesDatas () {
      const url = `${baseApiUrl}/programacao_datas`
      axios.get(url)
        .then(res => {
          this.programacoes_datas = res.data
        })
        .catch(showError)
    },
    CarregaDadosdoEmaildeCadastro () {
      axios.get(`${baseApiUrl}/dados_de_email_para_envio/${this.form.id_categoria}`)
        .then(res => {
          this.dados_email_cadastro = res.data
        })
        .catch(showError)
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  },
  mounted () {
    if (!this.$store.state.ficha_id_categoria) this.$router.push({ path: '/' })
    this.CarregaDados()
    this.CarregaProgramacoes()
    this.CarregaProgramacoesDatas()
    this.VerificaValorTaxaInscr()
    this.CarregaDadosdoEmaildeCadastro()
  }
}
</script>

<style scoped>
  .preftel {
    display: float-left;
    max-width: 60px;
  }
  .tel {
    display: float-left;
    max-width: 120px;
  }
  .inativo {
    color: red;
  }
</style>
